
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund-cancellation",
      function () {
        return require("private-next-pages/refund-cancellation/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund-cancellation"])
      });
    }
  